import Swiper, { Navigation, Pagination, Lazy, Autoplay, Controller } from 'swiper';

const swiperStart = new Swiper('.swiper--start', {
  modules: [ Navigation, Lazy, Autoplay ],
  speed: 600,
  slidesPerView: 1,
  // allowTouchMove: false,
  focusableElements: 'a, input, select, option, textarea, button, video, label',
  loop: true,
  navigation: {
    nextEl: '.swiper-nav--start--next',
    prevEl: '.swiper-nav--start--prev',
    disabledClass: 'is-disabled',
  },
  lazy: {
    enabled: true,
    loadOnTransitionStart: true,
    loadPrevNext: false,
  },
  // autoplay: {
  //   delay: 8000,
  //   disableOnInteraction: true,
  //   pauseOnMouseEnter: true,
  // },
  on: {
    slideChange: function() {
      swiperPreventFocus(this.slides, this.activeIndex, this.previousIndex);
    },
  }
});
function swiperPreventFocus(slides, currIndex, prevIndex) {
  slides.forEach((slide, index) => {
    let focusableElements = slide.querySelectorAll('a, button');
    if (index == currIndex) {
      focusableElements.forEach(element => {
        element.removeAttribute('tabIndex');
      });
    }
    else {
      focusableElements.forEach(element => {
        element.setAttribute('tabIndex', -1);
      });
    }
  })
}

const swiperHistory = new Swiper('.swiper--history', {
  modules: [ Navigation, Pagination, Lazy, Autoplay ],
  speed: 600,
  slidesPerView: 1,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-nav--history--next',
    prevEl: '.swiper-nav--history--prev',
    disabledClass: 'is-disabled',
  },
  pagination: {
    el: '.swiper-pagination--history',
    type: 'bullets',
    bulletClass: 'swiper-pagination__bullet',
    bulletActiveClass: 'current',
    clickable: true,
    renderBullet: function(index, className) {
      return `<button class="${className}">${this.slides[index].dataset.label}</button>`;
    },
  },
  lazy: {
    enabled: true,
    checkInView: true,
    loadOnTransitionStart: true,
    loadPrevNext: true,
  },
  autoplay: {
    delay: 8000,
    disableOnInteraction: true,
    pauseOnMouseEnter: true,
  },
  on: {
    init: function() {
      historyDynamicPagination(this.pagination, this.realIndex);
    },
    resize: function() {
      historyDynamicPagination(this.pagination, this.realIndex);
    },
    slideChange: function() {
      historyDynamicPagination(this.pagination, this.realIndex);
    },
  }
});

function historyDynamicPagination(pagination, activeIndex) {
  let paginationWidth = pagination.el.offsetWidth;
  let bulletWidth = pagination.bullets[0].offsetWidth;
  let marginWidth = parseInt(window.getComputedStyle(pagination.bullets[0])['margin-right']);
  let bulletMarginWidth = bulletWidth + marginWidth;
  let offset = 0;

  if (bulletMarginWidth * activeIndex > paginationWidth / 2) {
    offset = bulletMarginWidth * activeIndex - paginationWidth / 2 + bulletWidth / 2;

    let paginationContentWidth = bulletMarginWidth * pagination.bullets.length - marginWidth;
    if (offset > paginationContentWidth - paginationWidth) {
      offset = paginationContentWidth - paginationWidth;
    }
  }

  pagination.bullets.forEach(bullet => {
    bullet.style['transform'] = `translateX(${offset * -1}px)`;
  });
}

const swiperGallery = new Swiper('.swiper--gallery', {
  modules: [ Navigation, Pagination, Lazy, Autoplay ],
  speed: 600,
  allowTouchMove: false,
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-nav--next',
    prevEl: '.swiper-nav--prev',
    disabledClass: 'is-disabled',
  },
  pagination: {
    el: '.swiper-pagination--gallery',
    type: 'bullets',
    bulletClass: 'swiper-pagination__bullet',
    bulletActiveClass: 'current',
    clickable: true,
    // dynamicBullets: true,
    // dynamicMainBullets: 1,
    renderBullet: function(index, className) {
      let url = this.slides[index].dataset.url;
      return `<button class="${className}"><img class="${className}__img" src="${url}"/></button>`;
    },
  },
  lazy: {
    enabled: true,
    checkInView: true,
    loadOnTransitionStart: true,
    loadPrevNext: false,
  },
  autoplay: {
    delay: 8000,
    disableOnInteraction: true,
    pauseOnMouseEnter: true,
  },
  on: {
    init: function() {
      dynamicPaginationFix(this.pagination, this.realIndex);
    },
    slideChange: function() {
      dynamicPaginationFix(this.pagination, this.realIndex);
    },
  }
});

function dynamicPaginationFix(pagination, activeIndex) {
  const spacing = 10;
  let paginationWidth = pagination.el.offsetWidth;
  let bulletWidth = pagination.bullets[0].offsetWidth;
  let spacedBulletWidth = bulletWidth + spacing;
  let offset = -4; // move 2px right to fit outline with its offset
  // let offset = 0;

  if (spacedBulletWidth * activeIndex > paginationWidth / 2) {
    offset = spacedBulletWidth * activeIndex - paginationWidth / 2 + bulletWidth / 2;

    let paginationContentWidth = spacedBulletWidth * pagination.bullets.length - spacing;
    if (offset > paginationContentWidth - paginationWidth) {
      offset = paginationContentWidth - paginationWidth;
    }
  }

  pagination.bullets.forEach(bullet => {
    bullet.style['transform'] = `translateX(${offset * -1}px)`;
  });
}

const simpleGalleryContainers = document.querySelectorAll('.swiper--gallery-simple');
simpleGalleryContainers.forEach(simpleGalleryContainer => {
  let swiperSimpleGallery = new Swiper(simpleGalleryContainer, {
    modules: [ Navigation, Lazy, Autoplay ],
    speed: 600,
    allowTouchMove: false,
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-nav--next',
      prevEl: '.swiper-nav--prev',
      disabledClass: 'is-disabled',
    },
    lazy: {
      enabled: true,
      checkInView: true,
      loadOnTransitionStart: true,
      loadPrevNext: false,
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
      },
    }
  });
});
